import { FC } from "react";

import { getLogicByFieldType } from "./../../../../../../../helpers/getLogicByFieldType";
import { ICondition, IRule } from "./../../../../../../../store/logic/types";
import { IField } from "./../../../../../../../store/fields/types";
import LogicStateSelect from "./LogicStateSelect";

interface IProps {
    rule: IRule;
    condition: ICondition;
    fieldIds: IField[];
    index: number;
    setCurrentRule: (newRule: IRule) => void;
}

const StateSelect: FC<IProps> = ({ rule, condition, fieldIds, index, setCurrentRule }) => {
    let stateOptions = getLogicByFieldType(fieldIds, condition._id);

    return (
        <LogicStateSelect
            placeholder="Select a state"
            disabled={condition._id === undefined || condition._id === ""}
            handleChange={newKey => {
                rule.conditions[index].condition = newKey;
                setCurrentRule({ ...rule });
            }}
            options={stateOptions}
            valueKey={rule.conditions[index].condition}
        />
    );
};

export default StateSelect;
